export var carManagementReport = {
  name: "车辆运营报表",
  path: "/car-management-report",
  hidden: false,
  redirect: "noredirect",
  component: "Layout",
  elemCode: "18",
  sort: 5,
  alwaysShow: true,
  meta: {
    title: "车辆运营报表",
    icon: "external-link-outline",
    noCache: false
  },
  children: [{
    name: "CarManagementReport",
    path: "/car-management-report/index",
    hidden: false,
    component: "report/carManagementReport",
    elemCode: "19",
    meta: {
      title: "车辆运营报表",
      noCache: true
    }
  }]
};

// export const carManagementReport = {
//   name: "车辆运营报表",
//   path: "/car-attendance-rate-report",
//   hidden: false,
//   redirect: "noredirect",
//   component: "Layout",
//   elemCode: "10",
//   alwaysShow: true,
//   meta: {
//       title: "车辆运营报表",
//       icon: "external-link-outline",
//       noCache: false
//   },
//   children: [{
//       name: "CarManagementReport",
//       path: "/car-attendance-rate-report/index",
//       hidden: false,
//       component: "report/carManagementReport",
//       elemCode: "11",
//       meta: {
//           title: "车辆运营报表",
//           noCache: true
//       }
//   }]
// }